import * as React from 'react';
import { useState } from 'react';

import { cn } from '@codes/ui-kit/utils';
import { Eye, EyeOff } from 'lucide-react';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, placeholder, disabled, ...props }, ref) => {
        const [keyword, setKeyword] = useState<string>('');
        const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
        const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setKeyword(e.target.value);
        };

        const onReset = () => {
            setKeyword('');
        };
        const togglePasswordVisibility = (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            setIsPasswordVisible(!isPasswordVisible);
        };
        const isPasswordType = type === 'password';

        return (
            <div
                className={cn(
                    'h-10 relative flex gap-2 bg-transparent px-3.5 border rounded-lg transition-all duration-150',
                    disabled
                        ? 'border-border bg-muted/50 opacity-60'
                        : 'border-border hover:border-sub-title/40 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10',
                    className
                )}
            >
                <input
                    type={isPasswordType && isPasswordVisible ? 'text' : type}
                    onChange={onChange}
                    value={keyword}
                    disabled={disabled}
                    className={cn(
                        'h-full w-full bg-transparent text-sm font-medium file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-25'
                    )}
                    ref={ref}
                    placeholder={placeholder}
                    {...props}
                />
                <div className="flex items-center gap-[10px]">
                    {isPasswordType && (
                        <button className="shrink-0" onClick={togglePasswordVisibility}>
                            {isPasswordVisible ? <Eye className="w-5 h-5" /> : <EyeOff className="w-5 h-5" />}
                        </button>
                    )}
                    {/* {keyword.length !== 0 && (
                    <button onClick={onReset}>
                        <Image src="/assets/icons/circle_close.svg" alt="" />
                    </button>
                )} */}
                </div>
            </div>
        );
    }
);
Input.displayName = 'Input';

export { Input };
